import React, { useState } from 'react';
import { LogoutOutlined, FileDoneOutlined, ProfileOutlined, SnippetsOutlined, DashboardOutlined, MenuOutlined, CloseOutlined } from '@ant-design/icons';
import { ConfigProvider, Divider, Badge, Tooltip, Button } from 'antd';
import {Link} from 'react-router-dom';
import avatar from '../../uploads/avatar.png';
import { useNavigate } from 'react-router-dom';

const Navbar = () => {
  const navigate = useNavigate();
  const shortInfo = localStorage.getItem('shortinfo') !== null ? JSON.parse(localStorage.getItem('shortinfo')) : avatar;
  const imageUrl = shortInfo.Photo ? `data:image/jpeg;base64, ${shortInfo.Photo}` : avatar;
  const [menuVisibility, setMenuVisibility] = useState(false);

  const toggleMenu = (value) => {
    setMenuVisibility(value);
  }


  return <ConfigProvider
    theme={{
      token: {
        colorSplit: '#c9c9c9'
      },
    }}
  >   

    {menuVisibility === false ? (<div className='dashboard-menu-toggler'>
      <div className={'dashboard-menu-profile'}>
        <div className={'dashboard-menu-avatar'}>
          <img src={imageUrl} />
        </div>
        <h6>{shortInfo.Name}</h6>
      </div>
      <Button onClick={() => toggleMenu(true)} style={{ backgroundColor: '#fff' }}><MenuOutlined /></Button>
    </div>) : <div></div>}
      
    <div className='dashboard-menu'>
      <div className={'dashboard-menu-profile'}>
        <div className={'dashboard-menu-avatar'}>
          <img src={imageUrl} />
        </div>
        <h6>{shortInfo.Name}</h6>
      </div>
      <Divider />
      <div className='dashboard-menu-item' onClick={() => navigate('/dashboard')}>
        <DashboardOutlined className='dashboard-menu-item-icon' />
        <Link to={''} className='dashboard-menu-item-link'>Панель управления</Link>
      </div>
      <div className='dashboard-menu-item' onClick={() => navigate('/profile')}>
        <FileDoneOutlined className='dashboard-menu-item-icon' />
        <Link to={''} className='dashboard-menu-item-link'>Изменение персональных данных</Link>
      </div>
      <div className='dashboard-menu-item active' onClick={() => navigate('/cv')}>
        <ProfileOutlined className='dashboard-menu-item-icon' />
        <Link to={''} className='dashboard-menu-item-link'>Сформировать резюме</Link>
      </div>
      <div className='dashboard-menu-item' onClick={() => navigate('/applications')}>
        <ProfileOutlined className='dashboard-menu-item-icon' />
        <Link to={''} className='dashboard-menu-item-link'>Мои заявки</Link>
      </div>   
      <div className='dashboard-menu-item' onClick={() => navigate('/personnel_data')}>
        <SnippetsOutlined className='dashboard-menu-item-icon' />
        <Link to={''} className='dashboard-menu-item-link'>Мои кадровые данные</Link>
      </div>  
      {/* SD-229348 30.10.2025 Отключение функционала подачи заявлений работодателю
      <div className='dashboard-menu-item' onClick={() => navigate('/requests')}>
        <ProfileOutlined className='dashboard-menu-item-icon' />
        <Link to={''} className='dashboard-menu-item-link'>Подать заявление работодателю</Link>
      </div> */}
      {/* <Badge.Ribbon placement="end" text="В разработке">
        <Tooltip placement="right" title="В разработке" overlayStyle={{ fontSize: '12px', lineHeight: '19px' }}>
        </Tooltip>
      </Badge.Ribbon> */}
      <div style={{ position: 'absolute', bottom: '16px', left: '0', width: '100%' }}>
        <Divider />
        <div className='dashboard-menu-item' style={{border: 'none'}}  onClick={() => navigate('/logout')}>
          <LogoutOutlined className='dashboard-menu-item-icon' />
          <Link to={''} className='dashboard-menu-item-link'>Выход</Link>
        </div>
      </div>
    </div>  

    {menuVisibility === true ? (<div className='dashboard-menu-collapse'>
      <Button style={{ position: 'absolute', top: '9px', right: '15px', backgroundColor: '#fff' }} onClick={() => toggleMenu(false)}><CloseOutlined /></Button>
      <div className={'dashboard-menu-profile'}>
        <div className={'dashboard-menu-avatar'}>
          <img src={imageUrl} />
        </div>
        <h6>{shortInfo.Name}</h6>
      </div>
      <Divider />
      <div className='dashboard-menu-item' onClick={() => navigate('/dashboard')}>
        <DashboardOutlined className='dashboard-menu-item-icon' />
        <Link to={''} className='dashboard-menu-item-link'>Панель управления</Link>
      </div>
      <div className='dashboard-menu-item' onClick={() => navigate('/profile')}>
        <FileDoneOutlined className='dashboard-menu-item-icon' />
        <Link to={''} className='dashboard-menu-item-link'>Изменение персональных данных</Link>
      </div>
      <div className='dashboard-menu-item active' onClick={() => navigate('/cv')}>
        <ProfileOutlined className='dashboard-menu-item-icon' />
        <Link to={''} className='dashboard-menu-item-link'>Сформировать резюме</Link>
      </div>
      <div className='dashboard-menu-item' onClick={() => navigate('/applications')}>
        <ProfileOutlined className='dashboard-menu-item-icon' />
        <Link to={''} className='dashboard-menu-item-link'>Мои заявки</Link>
      </div>  
      <div className='dashboard-menu-item' onClick={() => navigate('/personnel_data')}>
        <SnippetsOutlined className='dashboard-menu-item-icon' />
        <Link to={''} className='dashboard-menu-item-link'>Мои кадровые данные</Link>
      </div>   
      {/* SD-229348 30.10.2025 Отключение функционала подачи заявлений работодателю
      <div className='dashboard-menu-item' onClick={() => navigate('/requests')}>
        <ProfileOutlined className='dashboard-menu-item-icon' />
        <Link to={''} className='dashboard-menu-item-link'>Подать заявление работодателю</Link>
      </div> */}
      {/* <Badge.Ribbon placement="end" text="В разработке">
        <Tooltip placement="right" title="В разработке" overlayStyle={{ fontSize: '12px', lineHeight: '19px' }}>
        </Tooltip>
      </Badge.Ribbon> */}
      <div className='dashboard-menu-item-logout' style={{ position: 'absolute', bottom: '16px', left: '0', width: '100%' }}>
        <Divider />
        <div className='dashboard-menu-item' style={{border: 'none'}}  onClick={() => navigate('/logout')}>
          <LogoutOutlined className='dashboard-menu-item-icon' />
          <Link to={''} className='dashboard-menu-item-link'>Выход</Link>
        </div>
      </div>
    </div>) : <div></div>} 
  </ConfigProvider>
};

export default Navbar;